// AUTO-GENERATED by scripts/build-blog-manifest.js. Do not edit.
export interface BlogArticle {
  slug: string;
  title: string;
  date: string;
  excerpt?: string;
  content: string;
}

export const articles: BlogArticle[] = [];
